// material-ui
import { styled } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';
import { LAYOUT_ZOOM_MAIN_CHAT_MIN_WIDTH_PX } from './layout-zoom-constants';

interface MainInnerStyleProps {
  borderRadius: number;
}

// ==============================|| MAIN LAYOUT - STYLED ||============================== //

const MainInnerContentStyled = styled('main', {
  shouldForwardProp: (prop) => prop !== 'borderRadius',
})<MainInnerStyleProps>(({ theme, borderRadius }) => {
  // הסידבארים כבר לא תופסים מקום כשהם סגורים (width: 0)
  // לכן התוכן תמיד יהיה ברוחב מלא

  return {
    backgroundColor:
      theme.palette.mode === ThemeMode.DARK ? theme.palette.dark[800] : theme.palette.grey[100],
    minWidth: LAYOUT_ZOOM_MAIN_CHAT_MIN_WIDTH_PX,
    minHeight: 0,
    width: 'auto',
    flex: '1 1 auto',
    height: '100%',
    overflowX: 'hidden',
    /** גלילה רק בתוך ילדי ה־Outlet — לא כאן (מונע כפילות פס גלילה עם רשימות/פאנלים) */
    overflowY: 'hidden',
    borderRadius: `${borderRadius}px`,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 2,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shorter + 200,
    }),
    /** Horizontal gutters: parent flex `gap` + `MainContentStyled` padding. */
    marginLeft: 0,
    marginRight: 0,
    /** במסך צר (טלפון) הרוחב המינימלי של הדסקטופ גדול מהמסך ויוצר גלילה אופקית */
    [theme.breakpoints.down('md')]: {
      minWidth: 0,
    },
  };
});

export default MainInnerContentStyled;
